module.exports = __webpack_public_path__ + "db9dbb1cc83f0aab740deff007f7895e.png";